<template>
  <div class="content">
    <div class="main">
      <p class="title">跳转失败</p>
      <div class="titleText">
        <span style="color:#409eff;margin-top:10px"></span>
      </div>
      <el-form v-model="user" class="formStyle">
        <el-form-item v-show="select_userName">
          <el-select
            v-model="user.userName"
            placeholder="请选择用户"
            @change="select_change"
            style="float:left;margin-left:30px;width:70%"
          >
            <el-option v-for="item in user.userList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="select_password">
          <el-input id="password" type="password" v-model="user.passWord" placeholder="请输入CA密码"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-button
          style="margin-top:10px;width:180px;font-size:18px;height:45px"
          type="primary"
          round
          @click="login_auto"
        >再次点击身份校验</el-button>
      </div>
      <a
        @click="register"
        style="margin-top:20px;display:inline-block;font-size:24px;"
      >账号校验失败，请点击此处前往苏州市施工图审查系统进行注册</a>
    </div>
  </div>
</template>

<script>
// import multibrowser from '../../../static/'

export default {
  data() {
    return {
      url: {
        autoLogin:'/censor/auto/autologin'
        // checkca: "censor/calogin/checkca",
        // censorLogin: "censor/calogin/login",
        // designLogin: "design/calogin/login",
        // drawLogin: "draw/calogin/login",
        // organizationCodeLogin: "/censor/tasks/organizationCodeLogin"
      },
      user: {
        userName: "",
        userList: [],
        passWord: ""
      },
      jsonData: "",
      certs: "",
      signCert: "",
      random: "",
      singType: "",
      loginType: "账号校验",
      caSeason: "",
      message: {
        name: "", //令牌
        params: {
          status: "",
          msg: ""
        }
      },
      organizationCode: "",
      ca_download: true,
      select_userName: false,
      select_password: false
      // id_Disabled:true,
    };
  },
  created(){
    if(this.$route.query.user){
      this.login_auto();
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //     this.init(); //初始化显示和选择证书
    // });
    // this.$nextTick(() => {
    //   window.addEventListener("message", this.parentMessage);
    // });
  },
  methods: {

    select_change(val) {
      this.selectVal = val;
    },

    identify() {
      //身份验证91420111MA4KL4W363
      if (this.loginType == "CA校验") {
        //CA校验
        // if(this.localOrgCode != this.organizationCode){
        //     this.caSeason = '当前登录账号与CA不匹配'
        //     return false;
        // }
        this.submit();
      } else {
        //机构代码校验
        this.caSeason = "正在验证,请稍后";
        this.message.params.msg = "正在验证,请稍后";
        this.message.name = "getCode"; //获取组织机构代码
        window.parent.postMessage(JSON.stringify(this.message), "*");
        // this.message.name = 'CAlogin';
        // this.message.params.status = true//返回成功
        // window.parent.postMessage(JSON.stringify(this.message), '*');
        // this.ca_download = false;
      }
    },
    select_radio(val) {
      if (val == "CA校验") {
        this.loginType == "CA校验";
        setTimeout(() => {
          this.init();
        }, 200);
      } else {
        this.caSeason = "";
        this.select_password = false; //密码输入框
        this.ca_download = false;
        // this.id_Disabled = false;
      }
    },
    register(){
      this.$router.push({name:"constructionRegister"});
    },
    login_auto() {
      let data = {};
      data.user=this.$route.query.user;
      data.password = this.$route.query.password;
      data.checkCode = this.$route.query.checkCode;
      data.sqh = this.$route.query.sqh;
      this.$http
        .post(
          this.url.autoLogin,
          data
        )
        .then(res => {
          if(res.data.status == "200"){
            this.$message.success("登录成功，欢迎回来");
            document.querySelector('body').setAttribute('style', 'background-image:url()');
            this.$store.commit('$_setStorage', {user: res.body.result});
            this.$store.commit('$_setLogin', '100');
            this.$store.commit('$_setDraw', '建设单位网上报审');
            this.$router.push("/constructionHome");
          } else {
            this.$message.error(res.body.message);
          }
        });
    },
    parentMessage: function(event) {
      var data = JSON.parse(event.data);
      if (data.name == "returnCode") {
        this.organizationCode = data.params.organizationCode;
        if (this.loginType == "CA校验") {
          if (this.localOrgCode == this.organizationCode) {
            // 获取的组织机构代码与key中的组织机构代码作比较
            this.caSeason = "";
            // this.id_Disabled = false;
            this.select_password = true;
            // this.getIdentify(this.organizationCode);
          } else {
            this.caSeason = "当前登录账号与CA不匹配";
            this.message.params.msg = "当前登录账号与CA不匹配";
          }
        } else {
          this.getIdentify(this.organizationCode);
        }
      }
    },
    getIdentify(data) {
      // 获取的组织机构代码与数据库中的组织机构代码作比较
      this.$http
        .get(
          this.url.organizationCodeLogin + "/" + data // data为传过来的组织机构代码
        )
        .then(res => {
          if (res.data.status === 200) {
            //比对成功
            this.caSeason = "验证通过";
            this.select_password = false; // 密码输入框
            this.message.name = "CAlogin";
            this.message.params.msg = "验证通过";
            this.message.params.status = true; // 返回成功
            window.parent.postMessage(JSON.stringify(this.message), "*");
            this.ca_download = false;
          } else {
            this.caSeason = "验证不通过";
            this.message.name = "CAlogin";
            this.message.params.msg = "验证不通过";
            this.message.params.status = false;
            window.parent.postMessage(JSON.stringify(this.message), "*");
          }
        });
    },
    submit() {
      //取一个随机数
      var random = "123哈哈哈";
      document.getElementById("randomData").value = random;
      this.random = random;
      // //下拉框选中哪一张证书
      var sign = this.certs.GetAt(0); //默认登陆选择第一个章
      var test = sign.getFriendlyName();
      //设置pin码
      this.singType = sign;
      sign.setUserPIN(this.user.passWord);
      //签名(0表示attach，1表示detach)
      var signedData1 = sign.PKCS7String(random, 1);
      var signedData = sign.PKCS7String(random, 0);
      var test1 = sign.getErrorString();
      var GetExtensionString = this.singType.GetExtensionString(
        "1.2.86.11.7.3",
        1
      );
      // var GetExtensionString = this.singType.GetExtensionString('1.2.86.11.7.1',0);
      //将签名值传到后台
      document.getElementById("signedData").value = signedData;
      this.sendAjaxLogin(signedData);
    },
    sendAjaxLogin(json) {
      //验证key密码
      this.encode(json);
      this.$http
        .post(
          this.url.checkca +
            "?signedData=" +
            this.jsonData +
            "&randomData=" +
            this.random
        )
        .then(res => {
          if (res.data.status === 200) {
            this.message.params.status = true;
            this.message.name = "CAlogin";
            window.parent.postMessage(JSON.stringify(this.message), "*"); // 验证通过
          } else {
            this.message.params.status = false;
            this.message.name = "CAlogin";
            window.parent.postMessage(JSON.stringify(this.message), "*"); // 验证不通过
          }
        });
    },
    login() {
      var url;
      if (this.$route.query.remark == "censor") {
        url = this.url.censorLogin;
      } else if (this.$route.query.remark == "survey") {
        url = this.url.designLogin;
      } else if (this.$route.query.remark == "drawing") {
        url = this.url.drawLogin;
      } else if (this.$route.query.remark == "supervise") {
        url = this.url.drawLogin;
      }
      this.$http
        .post(
          url +
            "?strData=" +
            this.random +
            "&strCert=" +
            this.random +
            "&strSign=" +
            this.user.userName
        )
        .then(res => {
          if (res.data.status == "200") {
            var jsons = JSON.parse(res.body.result);
            document
              . querySelector("body")
              .setAttribute("style", "background-image:url()");
            this.$store.commit("$_setStorage", { user: jsons });
            if (this.$route.query.remark === "censor") {
              this.$store.commit("$_setLogin", "100");
              this.$store.commit("$_setDraw", "建设单位");
              this.$router.push("/constructionHome");
            } else if (this.$route.query.remark === "survey") {
              this.$store.commit("$_setLogin", "200");
              this.$store.commit("$_setDraw", "勘察设计单位");
              this.$router.push("/designHome");
            } else if (this.$route.query.remark === "design") {
              this.$store.commit("$_setLogin", "200");
              this.$store.commit("$_setDraw", "勘察设计单位");
              this.$router.push("/designHome");
            } else if (this.$route.query.remark === "drawing") {
              this.$store.commit("$_setLogin", "300");
              this.$store.commit("$_setDraw", "审图机构");
              this.$router.push("/inspectDrawHome");
            } else if (this.$route.query.remark === "supervise") {
              this.$store.commit("$_setLogin", "300");
              this.$store.commit("$_setDraw", "监管机构");
              this.$router.push("/inspectSuperviseHome");
            }
            if (this.$route.query.remark == "censor") {
              this.$router.push("/constructionHome/HOME/censor");
            } else if (this.$route.query.remark == "design") {
              this.$router.push("/designHome/HOME/design");
            } else if (this.$route.query.remark == "drawing") {
              this.$router.push("/inspectDrawHome/HOME/draw");
            } else if (this.$route.query.remark == "supervise") {
              this.$router.push("/inspectSuperviseHome/HOME/supervise");
            }
          }
        });
    },
    encode(json) {
      this.jsonData = json
        .replace(/\+/g, "%2B")
        .replace(/\ /g, "%20")
        .replace(/\//g, "%2F")
        .replace(/\?/g, "%3F")
        .replace(/\#/g, "%23")
        .replace(/\&/g, "%26")
        .replace(/\=/g, "%3D");
      // .replace(/\%/g,'%25')
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/loginDocking.vue